import request from "@/utils/request";

export function getApplyList(data) {
  return request({ url: "/ntocc-basic-api/shipmentApply", method: "get", params: data });
}

export function getApplyDetail(code) {
  return request({ url: `/ntocc-basic-api/shipmentApply/${code}`, method: "get" });
}

export function updateApply(data) {
  return request({ url: "/ntocc-basic-api/shipmentApply", method: "put", data });
}

export function getApplyStatistics() {
  return request({ url: "/ntocc-basic-api/shipmentApply/statistics", method: "get" });
}

export function saveDueDiligence(data) {
  return request({ url: "/ntocc-basic-api/shipmentDd/save", method: "post", data });
}

export function getDueDiligence(applyCode) {
  return request({ url: `/ntocc-basic-api/shipmentDd/${applyCode}`, method: "get" });
}

export function csAudit(data) {
  return request({ url: "/ntocc-basic-api/shipmentFlow/csAudit", method: "post", data });
}

export function riskAudit(data) {
  return request({ url: "/ntocc-basic-api/shipmentFlow/riskAudit", method: "post", data });
}

export function resubmitApply(data) {
  return request({ url: "/ntocc-basic-api/shipmentFlow/resubmit", method: "post", data });
}

export function getFlowLogs(applyCode) {
  return request({ url: `/ntocc-basic-api/shipmentFlow/${applyCode}/logs`, method: "get" });
}

export function getInviteLink(applyCode) {
  return request({ url: "/ntocc-basic-api/shipmentApply/getInviteLink", method: "get", params: { applyCode } });
}
